import React from "react";

/**
 * Hlavička stránky. Na počítači nadpis vlevo a akce vpravo v jednom řádku;
 * když se akce vedle nadpisu nevejdou (telefon), spadnou na řádek pod něj
 * — nadpis a podtitul se nikdy nemačkají na jedno slovo na řádek.
 */
export default function PageHeader({ eyebrow, title, subtitle, actions, testid }) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-x-4 gap-y-3 mb-6" data-testid={testid}>
      <div className="min-w-0 flex-[1_1_200px]">
        {eyebrow && <div className="label-up text-muted mb-1.5">{eyebrow}</div>}
        <h1 className="text-[22px] font-800 text-ink leading-tight">{title}</h1>
        {subtitle && <p className="text-[13px] text-muted mt-1">{subtitle}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center justify-end gap-2 max-w-full">{actions}</div>}
    </div>
  );
}
